import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './News.css';
import Meta from './Meta';

function News() {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://api.itosoba.ru/api/news')
      .then(res => {
        if (!res.ok) {
          throw new Error('Ошибка при получении новостей');
        }
        return res.json();
      })
      .then(data => {
        setNewsList(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="loading">Загрузка новостей...</p>;
  if (error) return <p className="error">Ошибка: {error}</p>;

  const latestNews = newsList.slice(0, 3);

  return (
       <React.Fragment>
       <Meta
       title="«ИТ Особа» — провайдер интернет-услуг, видеонаблюдения, виртуальных офисов и других решений."
        description="Провайдер «IT Osoba» предлагает выгодные интернет-пакеты, аутсорсинг системного администрирования, услуги видеонаблюдения, виртуальные рабочие места, телефонию VoIP, облачное хранилище, проектирование инфраструктуры для бизнеса и прочие IT-услуги."
      />
    
    <div className="news-container">
      {latestNews.length === 0 ? (
        <p className="no-news">Нет новостей</p>
      ) : (
        <div className="news-list">
          {latestNews.map((newsItem) => (
            <Link
              key={newsItem.id}
              to={`/news/${newsItem.id}`}
              className="news-item"
            >
              <h3 className="news-title">{newsItem.title}</h3>
              {newsItem.image_url && (
                <img
                  src={`https://api.itosoba.ru${newsItem.image_url}`}
                  alt={newsItem.title}
                  className="news-image"
                />
              )}
              <p className="news-content">{newsItem.content.substring(0, 200)}...</p>
              <span className="news-date">
                {new Date(newsItem.date).toLocaleString()}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
     </React.Fragment>
  );
}

export default News;